/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchState } from './searchTypes';

const initialState: SearchState = {
  postCode: '',
  state: '',
  address: '',
  city: '',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updatePostCodeInSearch: (state, action: PayloadAction<string>) => {
      state.postCode = action.payload.toUpperCase();
    },
    updateCountryStateInSearch: (state, action: PayloadAction<string>) => {
      state.state = action.payload;
    },
    updateAddressInSearch: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
    updateCityInSearch: (state, action: PayloadAction<string>) => {
      state.city = action.payload;
    },
    updateSearchStateFromCache: (state, action: PayloadAction<SearchState>) => {
      return action.payload;
    },
  },
});

export const {
  updatePostCodeInSearch,
  updateCountryStateInSearch,
  updateAddressInSearch,
  updateCityInSearch,
  updateSearchStateFromCache,
} = searchSlice.actions;

export default searchSlice.reducer;
